export const FILTER_TYPES = {
    INPUT: 'input',
    SELECT: 'select',
    DATE: 'date',
    NUMBER: 'number',
    PLAN: 'plan'
};